exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".padding-add{padding-left:15px;padding-right:15px}.margin-small{margin:7px}.btn-margin{margin-right:5px;margin-left:5px}.inline{display:inline-block}.wizard-view{position:relative}.wizard-view .wizard-shade{position:absolute;display:table-cell;vertical-align:middle;text-align:center;top:0;left:0;width:100%;height:100%;background-color:#000;opacity:.2;z-index:10;cursor:not-allowed}.wizard-view .wizard-spinner{position:absolute;top:35%;right:20%;color:#000;opacity:1;z-index:11;cursor:not-allowed}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/device_add/styles.less
 ** module id = 610
 ** module chunks = 0
 **/